import { ScratchpadProvider } from '../components/Scratchpad/ScratchpadContext';
import { useBootstrapSelector } from '../redux/selectorHooks';
import { useCurrentUrl } from '../utils/routing';
import RightSideBar from '../components/RightSideBar';
import { Outlet } from 'react-router-dom';
import { DndEntity } from '../components/DndEntity';
import { IS_SCREENSHOT_MODE } from '../config/constants';

const LayoutOutlet = () => {
  const schemaConfig = useBootstrapSelector('schemaConfig');
  const { isReportInUrl, isDashboardInUrl, isCohortsInUrl, isViewCohortInUrl } =
    useCurrentUrl();

  const showSidebar =
    schemaConfig?.schemas?.length &&
    (isReportInUrl ||
      (isCohortsInUrl && !isViewCohortInUrl) ||
      isDashboardInUrl) &&
    !IS_SCREENSHOT_MODE;

  if (showSidebar) {
    return (
      <DndEntity>
        <ScratchpadProvider>
          <Outlet />
          <RightSideBar />
        </ScratchpadProvider>
      </DndEntity>
    );
  }

  return <Outlet />;
};

export default LayoutOutlet;
